module.exports = __webpack_public_path__ + "Roboto-Bold.ecdd509cadbf1ea78b8d.eot";


//////////////////
// WEBPACK FOOTER
// ./~/angular-bootstrap-md/font/roboto/Roboto-Bold.eot
// module id = 230
// module chunks = 2